import React from "react";

export default function TableLoader() {
    return (
        <div className="animate-pulse bg-tm-gray-300 rounded-btn w-1/2 h-4"/>
    )
}
